/* ==========================================================================
   Sprintbahn — GA4-Tracking (gemeinsamer Helfer)
   --------------------------------------------------------------------------
   Geladen von: sections/ceq-sprintbahn-planer.liquid und
   sections/ceq-sprintbahn-anfrage.liquid, jeweils VOR dem Modul, das sendet
   (defer haelt die Dokumentreihenfolge ein).

   Warum ohne `send_to`: GA4 (G-J16LSHP8Y8) haengt ueber die Google-&-YouTube-App
   an der Google-Tag-Mechanik, nicht an einem `gtag('config', ...)`. Mit
   `send_to` feuert gar kein Request — live geprueft und in
   snippets/ceq-web-vitals.liquid dokumentiert. Ohne `send_to` erreicht das
   Event GA4 zuverlaessig, geht dann aber auch an Google Ads (AW-323634827).
   Fuer `turf_inquiry_submit` ist das erwuenscht (dort als Conversion
   anlegbar), fuer die uebrigen Events unschaedlich.

   Sparsam bleiben: jedes Event kostet zwei Requests (GA4 + Ads). Darum wird
   NICHT jede Eingabe gemeldet, sondern nur vier Zeitpunkte —
   `turf_config_start`, `turf_preset_click`, `turf_inquiry_click`,
   `turf_inquiry_submit`.

   ⚠ Die eigenen Parameter (turf_type, length_m, …) erscheinen in den
   GA4-Berichten erst, wenn sie dort als benutzerdefinierte Dimensionen
   angelegt sind. Ohne das liegen sie nur in DebugView und BigQuery.
   ========================================================================== */

(function () {
  'use strict';

  window.ceqTurfTrack = function (name, params) {
    var payload = params || {};

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }

    /* Fallback: dataLayer, falls spaeter doch ein GA4-Tag in GTM angelegt wird.
       Der Container GTM-KNBRJ4C laeuft, enthaelt aber (Stand 18.08.2026) kein
       GA4-Tag. */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
  };
})();
